import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "not",
  "use": "not-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"not\"><path d=\"M32.25,121 C32.25,119.54425 32.712375,118.19425 33.49875,117.090625 L42.909375,126.500125 C41.804625,127.2865 40.45575,127.75 39,127.75 C35.277375,127.75 32.25,124.7215 32.25,121 M45.75,121 C45.75,122.45575 45.2865,123.80575 44.500125,124.909375 L35.0895,115.499875 C36.19425,114.7135 37.543125,114.25 39,114.25 C42.7215,114.25 45.75,117.2785 45.75,121 M45.363,114.635875 C43.66425,112.936 41.404125,112 39,112 C36.59475,112 34.33575,112.936 32.635875,114.635875 C30.934875,116.33575 30,118.595875 30,121 C30,123.404125 30.934875,125.66425 32.635875,127.364125 C34.33575,129.064 36.59475,130 39,130 C41.404125,130 43.66425,129.064 45.363,127.364125 C47.064,125.66425 48,123.404125 48,121 C48,118.595875 47.064,116.33575 45.363,114.635875\" transform=\"translate(-30 -112)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/not.svg
// module id = 1738
// module chunks = 0